// extracted by mini-css-extract-plugin
module.exports = {"cancel":"SubscriptionEditForm--styles-module_cancel-Y-f7M"};